import { client } from "../client/client";

export const getLoansReport = async () => {
  const response = await client.get(
    "/api/v1/report/loans?page=1&limit=10&fromDate=2023-11-23%2000%3A00%3A00&toDate=2023-11-24%2023%3A59%3A59&status=Active&loan_type=0&repay_range=0-6000&type=report&loan_duration=0-1",
  );
  return response;
};

export const getAllLoansReport = async (loan_type) => {
  const response = await client.get(
    `/api/v1/report/loans?page=1&limit=10&fromDate=2023-11-23%2000%3A00%3A00&toDate=2023-11-24%2023%3A59%3A59&status=Active&loan_type=${loan_type}&repay_range=0-6000&type=report&loan_duration=0-1`,
  );
  return response;
};

export const getLoansFilters = async (
  page,
  limit,
  fromDate,
  toDate,
  status,
  loan_type,
  repay_range,
  type,
  loan_duration,
  query,
) => {
  const response = await client.get(
    `/api/v1/report/loans?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}&status=${status}&loan_type=${loan_type}&repay_range=${repay_range}&type=${type}&loan_duration=${loan_duration}&q=${query}`,
  );
  return response;
};

export const getSingleLoanCustomer = async (
  customer_id,
  loan_code,
  product_id,
) => {
  try {
    const response = await client.get(
      `/api/v1/report/loan?customer_id=${customer_id}&loan_code=${loan_code}&product_id=${product_id}`,
    );
    return response?.data;
  } catch (error) {
    console.error("Error fetching single loan customer:", error);
    throw error;
  }
};

export const exportAllLoans = async (
  type,
  limit,
  page,
  fromDate,
  toDate,
  status,
  loan_type,
  repay_range,
  loan_duration,
  q,
) => {
  const response = await client.get(
    `api/v1/report/loans/all?format=${type}&limit=${limit}&page=${page}&fromDate=${fromDate}&toDate=${toDate}&status=${status}&loan_type=${loan_type}&repay_range=${repay_range}&type=filter&loan_duration=${loan_duration}&q=${q}`,
    {
      headers: {
        "Content-Type": type === "pdf" ? "application/pdf" : "text/csv",
      },
      responseType: "arraybuffer",
    },
  );
  return response.data;
};

export const exportSelectedLoans = async (type, transactions) => {
  const response = await client.post(
    `/api/v1/report/loans/export-selected?format=${type}`,
    transactions,
    { responseType: "arraybuffer" },
  );

  return response?.data;
};

export const paymentHistory = async (customer_id, loan_code, product_id) => {
  try {
    const response = await client.post("/api/v1/loan/payment_transactions", {
      customer_id: customer_id,
      type: "payment_transactions",
      prod_id: product_id,
      org_code: process.env.REACT_APP_ORG_CODE,
      loan_code: loan_code,
    });

    return response?.data;
  } catch (error) {
    console.error("Error fetching payment history:", error);
    throw error;
  }
};

export const getGuarantors = async (loancode) => {
  try {
    const response = await client.get(
      `/api/v1/guarantors/guarantors/${loancode}`,
    );
    return response?.data;
  } catch (error) {
    console.error("Error fetching guarantors:", error);
    throw error;
  }
};

export const searchGuarantorCandidates = async ({
  query,
  borrowerId,
  limit,
}) => {
  try {
    const response = await client?.get(
      "/api/v1/guarantors/admin/search-candidates",
      {
        params: {
          query,
          borrowerId,
          limit,
        },
      },
    );

    return response?.data;
  } catch (error) {
    console.error("Error searching guarantor candidates:", error);
    throw error;
  }
};

export const linkGuarantorToExistingLoan = async (payload) => {
  try {
    const response = await client.post(
      "/api/v1/guarantors/admin/link-existing-loan",
      payload,
    );

    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanGuarantorshipSummary = async ({ loanCode, loanAmount }) => {
  try {
    const response = await client.get(
      `/api/v1/guarantors/admin/loan/${loanCode}`,
      {
        params: {
          loanAmount,
        },
      },
    );

    return response?.data;
  } catch (error) {
    console.error("Error fetching loan guarantorship summary:", error);
    throw error;
  }
};

export const getLoanStatements = async (loanCode) => {
  try {
    const response = await client.get(
      `/api/v1/loan/statements/by-loan-code/${loanCode}`,
    );
    return response?.data;
  } catch (error) {
    console.error("Error fetching loan statements:", error);
    throw error;
  }
};

export const deleteGuarantor = async (payload) => {
  try {
    const { data } = await client.delete("/api/v1/guarantors/remove", {
      data: payload,
    });
    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const overrideGuarantorStatus = async (payload) => {
  try {
    const { data } = await client.patch(
      "/api/v1/guarantors/update-status",
      payload,
    );
    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const approveLoan = async (payload) => {
  try {
    const { data } = await client.post(`/api/v1/loan/approve`, payload);
    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getMemberDetails = async (customerId) => {
  try {
    const { data } = await client.get(`/api/v1/customer/${customerId}`);
    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanApprovals = async (loanCode) => {
  try {
    const response = await client.get(`/api/v1/loan/approvals/${loanCode}`);
    return response?.data;
  } catch (error) {
    console.error("Error fetching guarantors:", error);
    throw error;
  }
};

export const disburseFunds = async (payload) => {
  try {
    const response = await client.post("/api/v1/loan/admin/disburse", payload);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const loanLimitCheck = async (payload) => {
  try {
    const response = await client.post("/api/v1/loan/eligibility", payload);
    return response?.data?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const bankRecords = async (payload) => {
  try {
    const response = await client.post("/api/v1/loan/bankdetails", payload);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const declineDisburse = async (loanCode, description, file) => {
  try {
    const formData = new FormData();
    formData.append("loanCode", loanCode);
    formData.append("description", description);

    if (file) {
      formData.append("file", file);
    }

    const response = await client.post(
      `/api/v1/loan/disburse/decline`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const loanApprovals = async (loanCode) => {
  try {
    const response = await client.get(`/api/v1/loan/approvals/${loanCode}`);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addLoanPaymentManually = async (payload) => {
  try {
    const response = await client.post(
      "/api/v1/transaction/manual-transaction-loan",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return response.data?.data;
  } catch (error) {
    console.error("Error in manualTransaction:", error);
    throw error?.response?.data || error;
  }
};

export const eligibilityCheck = async (payload) => {
  try {
    const response = await client.post("/api/v1/loan/admin", payload);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const guarantorEligibilityCheck = async (id) => {
  try {
    const response = await client.get(`/api/v1/guarantors/loan-limit/${id}`);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const topUpEligibilityCheck = async ({
  mobile,
  orgCode,
  prodId,
  loanCode,
}) => {
  try {
    const response = await client.post(`/api/v1/loan/eligibility`, {
      mobile,
      org_code: orgCode,
      prod_id: prodId,
      type: "top_up_loan",
      loan_code: loanCode,
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const emergencyEligibilityCheck = async (borrowerId) => {
  try {
    const response = await client.post(
      "/api/v1/loan/emergency-loan-limit-wjwt",
      { borrowerId: borrowerId },
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const createProductAccount = async (payload) => {
  try {
    const response = await client.post("/api/v1/account", payload);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const applyDigitalLoan = async (payload) => {
  try {
    const response = await client.post("/api/v1/loan/admin", payload);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
export const applyTopUpLoan = async (payload) => {
  try {
    const response = await client.post("api/v1/loan/top-up", payload);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addGuarantor = async (payload) => {
  try {
    const response = await client.post(
      "/api/v1/guarantors/request/admin",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getManualLoanGuarantors = async (loanCode, id) => {
  try {
    const response = await client.get(
      `/api/v1/guarantors/requests/${loanCode}/admin/${id}`,
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const respondWithProof = async ({
  guarantorId,
  requestId,
  status,
  amountGuaranteed,
  responseReason,
  proofFile,
}) => {
  try {
    const formData = new FormData();

    formData.append("status", status);
    formData.append("amountGuaranteed", amountGuaranteed ?? "");
    formData.append("responseReason", responseReason ?? "");

    if (proofFile) {
      formData.append("proof", proofFile);
    } else {
      // MUST send empty proof field
      formData.append("proof", "");
    }

    const response = await client.post(
      `/api/v1/guarantors/${guarantorId}/respond-with-proof/${requestId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error responding with proof:", error);
    throw error?.response?.data || error;
  }
};

export const uploadStatementFile = async ({
  file_name,
  file_path,
  statement_bank_code,
  statement_code,
  statement_type,
  mobile_no,
  customer_id,
  statement_id,
  id_no,
}) => {
  try {
    const { data } = await client.post("/api/v1/loan/upload_file/admin", {
      file_name,
      file_path,
      statement_bank_code,
      statement_code,
      statement_type,
      mobile_no,
      customer_id,
      statement_id,
      id_no,
    });

    return data;
  } catch (error) {
    console.error(
      "Error uploading statement file:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const analyseLoanStatementByUrl = async ({
  file_name,
  file_path,
  statement_bank_code,
  statement_code,
  statement_type,
  mobile_no,
  customer_id,
  id_no,
}) => {
  try {
    const { data } = await client.post("/api/v1/loan/admin/analyse", {
      file_name,
      file_path,
      statement_bank_code,
      statement_code,
      statement_type,
      mobile_no,
      customer_id,
      id_no,
    });

    return data;
  } catch (error) {
    console.error(
      "Error analysing loan statement:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// export const uploadStatementFile = async ({
//   file_name,
//   file_path,
//   statement_bank_code,
//   statement_code,
//   statement_type,
//   mobile_no,
//   customer_id,
//   id_no,
// }) => {
//   try {
//     const response = await client.post("/api/v1/loan/upload_file/admin", {
//       file_name: file_name,
//       file_path: file_path,
//       statement_bank_code: statement_bank_code,
//       statement_code: statement_code,
//       statement_type: statement_type,
//       mobile_no: mobile_no,
//       customer_id: customer_id,
//       id_no: id_no,
//     });

//     return response?.data;
//   } catch (error) {
//     console.error("Error uploading statement file:", error);
//     throw error;
//   }
// };

// export const removeGuarantor = async (payload) => {
//   try {
//     const response = await client.delete("api/v1/guarantors/remove", {
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: payload,
//     });
//     return response.data;
//   } catch (error) {
//     throw error?.response?.data || error;
//   }
// };
